import React from "react";
import { createRoot } from "react-dom/client";
import App from "./app.jsx";

const el = document.getElementById("root");
if (!el) {
  throw new Error("Missing #root element. Check your HTML template.");
}

createRoot(el).render(<App />);
